import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// /import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { useAuth } from "../../../../../../context/AuthContext";

const ViewProfileDealer = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [roledd, setRoledd] = useState([]);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};
  const Token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const [userTypedd, setUserTypedd] = useState([]);
  console.log(data, "BusinessPartnerID");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  // const { setProfileImg } = useAuth();

  const dealerId = localStorage.getItem("dealerId");

  const BUSINESSPARTNERID = data?.business_partner_id;
  const [dealer, setDealer] = useState([]);

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    roleDropdown();
  }, []);

  const roleDropdown = async () => {
    try {
      const payload = {
        business_partner_id:
          userType === "superadmin"
            ? formData?.business_partner_id
            : businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const roleOptions = data.map((role) => ({
        value: role.ID,
        label: role.NAME,
      }));
      setRoledd(roleOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const handleFormSubmit = async (formData) => {
    console.log("formdatadealer", formData);

    const errors = {};
    let isValid = true;
    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this dealer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const safeDealerName = (formData.dealer_name || "").replace(
            /[^a-zA-Z0-9\s.-]/g,
            ""
          );

          const safeDealerId = parseInt(dealerId);
          if (isNaN(safeDealerId)) return;

          const payload = new FormData();
          payload.append("dealer_name", safeDealerName);
          payload.append("contact_no", formData.contact_no);
          payload.append("dealer_address", formData.dealer_address);
          payload.append("email_id", formData.email_id);
          payload.append("pan", formData.pan);
          payload.append("gst", formData.gst);
          payload.append("country_id", formData.country_id);
          payload.append("state_id", formData.state_id);
          payload.append("city_id", formData.city_id);
          payload.append("dealer_pin_code", formData.pincode);
          payload.append("status", formData.status === true ? 1 : 0);
          payload.append("remarks", formData.remarks || null);

          // Append image only if it's a File (not already a URL string)
          if (formData.productimage instanceof File) {
            payload.append("dealer_logo", formData.productimage);
          }

          const response = await axiosInstance.patch(
            `/dealer/dealerProfileEdit/${dealerId}`,
            payload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          // Swal.fire({
          //   title: "Success",
          //   text: "Dealer updated successfully!",
          //   icon: "success",
          //   confirmButtonText: "OK",
          // }).then(() => {
          //   // navigate(ROUTES_NAVIGATION.DEALERLIST);
          // });

          if (response.status === 200) {
            // const updatedLogoFileName = response.data?.data?.data?.dealer_logo;
            // const imageUrl = `${process.env.REACT_APP_API_BASE_URL}upload/${updatedLogoFileName}`;
            // console.log(imageUrl, "imageUrl")
            // // Update AuthContext + localStorage
            // setProfileImg(imageUrl); // From useAuth
            // localStorage.setItem("profileImage", imageUrl);

            Swal.fire({
              title: "Success",
              text: "Dealer updated successfully!",
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error updating dealer:", error);
          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Your changes were not saved.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    });
  };

  const fetchDealerEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/dealer/editImage/${dealerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const fetchedData = response.data.data;
      const transformedData = {
        business_partner_id: fetchedData.business_partner_id,
        dealer_code: fetchedData.dealer_code,
        dealer_name: fetchedData.dealer_name,
        dealer_desc: fetchedData.dealer_desc,
        contact_no: fetchedData.contact_no,
        dealer_address: fetchedData.dealer_address,
        email_id: fetchedData.email_id,
        tin: fetchedData.tin,
        pan: fetchedData.pan,
        gst: fetchedData.gst,
        // pincode:fetchedData.pincode,
        country_id: fetchedData.country_id,
        state_id: fetchedData.state_id,
        city_id: fetchedData.city_id,
        pincode: fetchedData.dealer_pin_code,
        // role_id: parseInt(fetchedData.role_id, 10),
        productimage: fetchedData?.dealer_logo,
        status: fetchedData.status === 1 ? true : false,
      };
      setFormData(transformedData);
      setDealer(fetchedData);
      console.log(formData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDealerEdit();
  }, []);
  const DealerInputs = [
    // {
    //   name: "dealer_code",
    //   label: "Dealer Code",
    //   type: "text",
    //   // required: true,
    //   disabled:true,
    //   gridClass: "col-lg-4",
    //   placeholder:"Enter Dealer Code",

    // },
    {
      name: "dealer_name",
      label: "Dealer Name",
      placeholder: "Enter Dealer Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
        maxLength: 20,
      },
    },

    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: "Contact No. should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit Contact No.",
      },
    },
    {
      name: "dealer_address",
      label: "Dealer Address",
      placeholder: "Enter Dealer Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },
    },

    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: {
        // required: true,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
        maxLength: 10,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "gst",
      label: "GST No.",
      type: "text",
      placeholder: "Enter GST No.",
      validation: {
        // required: true,
        pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
        message: "Please enter a valid 15-character GST number",
        maxLength: 15,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "productimage",
      label: "Upload Dealer Logo",
      type: "file",
      required: true,
      gridClass: "col-lg-6",
      validation: { required: true },
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">View Profile Dealer</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Dealer Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                if (!isFormSubmitted) {
                  handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
                }
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default ViewProfileDealer;
